module.exports = __webpack_public_path__ + "static/media/bandwidth_thumb_home_2.2f072fe1.mp4";